import { Dispatch, SetStateAction } from 'react';

import { Log } from '@common/log-manager';

import { useChipAndSortingFilterUBL } from '../log/useChipAndSortingFilterUBL';
import { ChipAndSortingComponentType, ShopUxUbl } from '../types';
import { FilterParam } from '../types/param';

interface Props {
  sortComponent: Omit<ChipAndSortingComponentType, 'type'>;
  onChangeFilter: (params: FilterParam) => void;
  setColumnCount: Dispatch<SetStateAction<2 | 3>>;
  log: Partial<Log> & { navigation: string };
}

export const useChipAndSortingFilter = ({ sortComponent, onChangeFilter, setColumnCount, log }: Props) => {
  const { sorting_item_list, filter_chip_item_list } = sortComponent;

  const popularChipFilterId = filter_chip_item_list.find((item) => item.name === '인기순')?.id ?? '';

  const selectedSortingItemId = sorting_item_list.filter((item) => item.selected)[0]?.id || '';
  const selectedFilterChipIds = filter_chip_item_list.filter((item) => item.selected).map((item) => item.id);

  const { clickSortingFilterUBL, clickGridViewUBL, clickFilterChipUBL } = useChipAndSortingFilterUBL({
    log,
  });

  const onChangeSorting = (id: string, ubl?: ShopUxUbl | null) => {
    clickSortingFilterUBL(ubl);
    onChangeFilter({
      check_button_item_ids: selectedFilterChipIds,
      sorting_item_id: id,
      sub_filter_id_list: [],
    });
  };

  const onChangeFilterChip = (id: string, checked: boolean, ubl?: ShopUxUbl | null) => {
    const newChipIds = checked ? [...selectedFilterChipIds, id] : selectedFilterChipIds.filter((item) => item !== id);
    clickFilterChipUBL(ubl);
    onChangeFilter({
      check_button_item_ids: newChipIds,
      sorting_item_id: id === popularChipFilterId ? null : selectedSortingItemId,
      sub_filter_id_list: [],
    });
  };

  const onChangeGridView = (ubl?: ShopUxUbl | null) => {
    clickGridViewUBL(ubl);
    setColumnCount((prev) => (prev === 2 ? 3 : 2));
  };

  return {
    onChangeSorting,
    onChangeFilterChip,
    onChangeGridView,
  };
};
